import { useState } from "react";
import "./cardSuperbowl.sass";

// Array estático con los puntos de los wildcard
const WILDCARD_POINTS = {
  "HOU": 30,
  "PIT": 6,
  "BUF": 27,
  "JAX": 24,
  "LAC": 3,
  "NE": 16,
  "LA": 34,
  "CAR": 31,
  "SF": 23,
  "PHI": 19,
  "GB": 27,
  "CHI": 31
};

const DIVISIONAL_POINTS = {
  "NE": 28,
  "DEN": 33,
  "BUF": 30,
  "HOU": 16,
  "SF": 6,
  "SEA": 41,
  "CHI": 17,
  "LA": 20,
};

const CONFERENCE_POINTS = {
  "NE": 10,
  "DEN": 7,
  "SEA": 31,
  "LA": 27
};

export default function CardSuperbowl({
  position,
  teamLogo, teamName,
  score, matchupId,
  onTeamSelect, isSelected, disabled, iswildcard, isDivisional, isConference
}) {
  const [isActive, setIsActive] = useState(false);

  // Obtener los puntos del wildcard si existen
  const wildcardPoints = WILDCARD_POINTS[teamName];
  const divisionalPoint = DIVISIONAL_POINTS[teamName];
  const conferencePoint = CONFERENCE_POINTS[teamName];

  const handleCardClick = () => {
    if (!disabled) {
      if (isSelected !== true) {
        if (onTeamSelect) {
          setIsActive(!isActive);
          onTeamSelect({
            matchupId,
            team: {
              position,
              logo: teamLogo,
              name: teamName,
              score
            }
          });
        }
      }
    }
  };

  return (
    <div className={`card-superbowl ${isActive ? "active" : ""} ${isSelected && !isDivisional && !isConference ? "selected" : ""}`} onClick={handleCardClick}>
      <div className="card-position">{position}</div>

      <div className="card-content">
        <img src={teamLogo} alt={teamName} className="card-logo" />
      </div>

      <div className="card-wildcard-points">
        {(wildcardPoints && iswildcard) ? <p>{wildcardPoints}</p> : (divisionalPoint && isDivisional) ? <p>{divisionalPoint}</p> : (conferencePoint && isConference) && <p>{conferencePoint}</p>}
      </div>

      <div className="card-superbowl-footer">
        <p className="card-superbowl-team-name">{teamName}</p>
      </div>
    </div>
  );
}